import React, { useState, useEffect, useRef } from "react";
import LoginPage from "../Login/LoginPage";
import Topbar from "../UIcomponents/Topbar";
import Sidebar from "../UIcomponents/Sidebar";
import { QueriesLog } from "../Query/QueriesLog";
import { LeadLog } from "../Lead/LeadLog";
import "./Dashboard.css";

const Dashboard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeNav, setActiveNav] = useState("dashboard");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const pageScrollTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Hide page-level vertical scrollbar at rest; show it only when scrolling
  useEffect(() => {
    const handlePageScroll = () => {
      document.documentElement.classList.add("is-scrolling");
      if (pageScrollTimerRef.current) clearTimeout(pageScrollTimerRef.current);
      pageScrollTimerRef.current = setTimeout(() => {
        document.documentElement.classList.remove("is-scrolling");
      }, 600);
    };

    window.addEventListener("scroll", handlePageScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handlePageScroll);
      if (pageScrollTimerRef.current) clearTimeout(pageScrollTimerRef.current);
    };
  }, []);

  const handleLogin = (secretKey: string) => {
    if (secretKey) {
      setIsAuthenticated(true);
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setActiveNav("dashboard"); // reset to default tab
  };

  const renderActivePanel = () => {
    if (activeNav === "queries") {
      return (
        <div className="admin-viewport-transparent">
          <QueriesLog />
        </div>
      );
    }

    if (activeNav === "Lead") {
      return (
        <div className="admin-viewport-transparent">
          <LeadLog />
        </div>
      );
    }

    const pageTitles: Record<string, string> = {
      dashboard: "Analytics Dashboard",
      queries: "Queries Log",
      kms: "Knowledge Management System (KMS)",
      help: "Help & Support Center",
      health: "System Health heartbeat Monitor",
      settings: "Admin Settings Panel",
    };

    const currentTitle = pageTitles[activeNav] || "Dashboard";
    const currentLabel = activeNav.toUpperCase();

    return (
      <div className="admin-viewport">
        <h2 className="viewport-title">{currentTitle}</h2>
        <p className="viewport-description">
          Welcome to the {currentTitle} area. You can manage and monitor your app metrics here.
        </p>
        
        <div className="placeholder-card">
          <i className="fa-solid fa-hourglass-half placeholder-icon" />
          <h3>{currentLabel} Content Loading...</h3>
          <p>The visual panels and stats for this section are being prepared.</p>
        </div>
      </div>
    );
  };

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  const activePageLabel = activeNav.charAt(0).toUpperCase() + activeNav.slice(1);

  return (
    <div className="admin-layout">
      <Topbar activePage={activePageLabel} onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      <div className="admin-body">
        <Sidebar
          activeNav={activeNav}
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onNavChange={(nav) => {
            if (nav === "logout") {
              setShowLogoutConfirm(true);
            } else {
              setActiveNav(nav);
            }
          }}
        />
        {renderActivePanel()}
      </div>
      {sidebarOpen && (
        <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
      )}

      {showLogoutConfirm && (
        <div className="logout-modal-overlay">
          <div className="logout-modal-card">
            <div className="logout-modal-icon-container">
              <i className="fa-solid fa-arrow-right-from-bracket logout-modal-icon" />
            </div>
            <h2 className="logout-modal-title">Confirm Logout</h2>
            <p className="logout-modal-text">
              Are you sure you want to log out of the admin panel?
            </p>
            <div className="logout-modal-actions">
              <button
                className="logout-btn-cancel"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="logout-btn-confirm"
                onClick={() => {
                  setShowLogoutConfirm(false);
                  handleLogout();
                }}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;


